import * as T from 'prop-types';
import styled from 'styled-components/macro';
import LoadingSpinner from 'utils/old-ui-commons/loading-spinner';

import { Flex, Icon, Text } from '@olist/united';

export const testIdPrefix = 'step-title-icon__';

const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${LoadingSpinner} {
    height: 18px;
    margin: 0;
    width: 18px;
  }
`;

const Title = (props) => <Text.Small fontWeight="semibold" lineHeight="1.5" {...props} />;

const StepTitleIcon = ({ isActive, isCompleted, isLoading, isLocked, title }) => {
  const loading = (
    <Wrapper data-testid={`${testIdPrefix}loading`}>
      <Title color="foundation.shadeDarker">{title}</Title>
      <LoadingSpinner />
    </Wrapper>
  );
  const locked = (
    <Wrapper data-testid={`${testIdPrefix}locked`}>
      <Title color="foundation.shadeDarker">{title}</Title>
      <Icon name="lock-fill" size="24px" color="foundation.shadeMedium" />
    </Wrapper>
  );
  const completed = (
    <Wrapper data-testid={`${testIdPrefix}completed`}>
      <Title color="foundation.shadeDark">{title}</Title>
      <Icon name="success-circle-fill" size="24px" color="foundation.successDefault" />
    </Wrapper>
  );
  const active = (
    <Wrapper data-testid={`${testIdPrefix}active`}>
      <Title color="foundation.shadeDarker">{title}</Title>
      <Icon name="arrow-right-outline" size="24px" color="foundation.primaryDefault" />
    </Wrapper>
  );
  const normal = (
    <Wrapper data-testid={`${testIdPrefix}normal`}>
      <Title color="foundation.shadeDarker">{title}</Title>
      <Icon name="arrow-right-outline" size="24px" color="foundation.shadeMedium" />
    </Wrapper>
  );

  if (isLoading) return loading;
  if (isLocked) return locked;
  if (isCompleted) return completed;
  if (isActive) return active;

  return normal;
};

StepTitleIcon.propTypes = {
  isActive: T.bool,
  isCompleted: T.bool,
  isLocked: T.bool,
  isLoading: T.bool,
  title: T.string.isRequired,
};

StepTitleIcon.defaultProps = {
  isActive: false,
  isCompleted: false,
  isLocked: false,
  isLoading: false,
};

export default StepTitleIcon;
